import "bootstrap/dist/css/bootstrap.min.css";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom/client";
import {
  GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { AvailableModulesProviderWrapper } from "./context/AvailableModulesContext";
import { DynamicComponentsProviderWrapper } from "./context/DynamicComponentsContext";
import { IntlProviderWrapper } from "./context/IntlContext";
import { ScheduleProvider } from "./context/ScheduleContext";
import { AuthDTO } from "./models/AuthDTO";
import reportWebVitals from "./reportWebVitals";
import { AuthService } from "./services/AuthService";
import "./styles/index.css";
import { SettingsService } from "./services/SettingsService";

const service: AuthService = new AuthService();
const settingsService: SettingsService = new SettingsService();

Promise.all([
  service.GetUser(),
  settingsService.GetRecaptchaKey()
]).then(([userResult, recaptchaResult]) => {
  let user: AuthDTO | null = null;
  let recaptchaKey = "";

  if (
    userResult.success === true &&
    userResult.obj != null &&
    userResult.obj.token != null
  ) {
    user = userResult.obj;
  }

  if (
    recaptchaResult.success === true &&
    recaptchaResult.obj != null &&
    recaptchaResult.obj.value
  ) {
    recaptchaKey = recaptchaResult.obj.value;
  }

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
      <IntlProviderWrapper>
        <CookiesProvider>
          <DynamicComponentsProviderWrapper>
            <AvailableModulesProviderWrapper>
              <AuthProvider user={user}>
                <ScheduleProvider>
                  <App />
                </ScheduleProvider>
              </AuthProvider>
            </AvailableModulesProviderWrapper>
          </DynamicComponentsProviderWrapper>
        </CookiesProvider>
      </IntlProviderWrapper>
    </GoogleReCaptchaProvider>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
